var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.795 16.9066L9.72995 18.9156C9.37195 19.2636 8.77295 19.1096 8.62795 18.6316L7.25195 14.1016",
    stroke: "#0A0A0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1041 10.9275C14.1041 10.9275 11.5151 13.2635 10.1871 14.4625C9.79008 14.8205 9.82308 15.4505 10.2531 15.7675L15.6311 19.7405C16.1601 20.1315 16.9161 19.8445 17.0531 19.2005L19.6941 6.75348C19.8221 6.15148 19.2311 5.64848 18.6571 5.86948L3.14208 11.8535C2.68508 12.0295 2.70708 12.6825 3.17408 12.8285L7.25108 14.1005",
    stroke: "#0A0A0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.5308d57cbb708002dccd30b955fc8c25.svg";
export { ForwardRef as ReactComponent };